import ReactGA4 from 'react-ga4';

const trackCustomGA4Event = (eventName: string, params: Record<string, unknown> = {}) => {
  console.log(
    "GA4 Event:", 
    eventName, 
    params, 
    sessionStorage.getItem("propertyCode"), sessionStorage.getItem("isInternalUser") ? "internal" : "external"); 
  ReactGA4.event(eventName, { 
    ...params, 
    transport_type: "beacon",
  });
};

export default trackCustomGA4Event;